import { useMutation } from '@tanstack/react-query';
import type { ConfigurationRequest } from '../types/Organization';

export default function usePostOrganizationNotification() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: ConfigurationRequest) => {
      const response = await fetch('/agent/api/organization_notification', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(params),
      });
      return await response.json();
    },
  });
}
